<template>
  <div class="space-y-3">
    <!-- Loader -->
    <template v-if="items && items.length <= 0">
      <div v-for="n in 5" :key="`shimmer-${n}`" class="border rounded-lg">
        <div class="animate-pulse p-4 flex space-x-4 rtl:space-x-reverse">
          <div class="bg-shimmer rounded w-20 h-20"></div>
          <div class="flex-grow">
            <div class="h-5 w-24 bg-shimmer rounded"></div>
            <div class="h-3 mt-3 bg-shimmer rounded"></div>
            <div class="h-3 mt-1 bg-shimmer rounded"></div>
            <div class="h-3 mt-1 bg-shimmer rounded"></div>
            <div class="h-3 mt-1 bg-shimmer rounded"></div>
            <div class="h-3 w-48 mt-1 bg-shimmer rounded"></div>
            <div class="h-10 mt-3 w-36 bg-shimmer rounded"></div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <StoreProductContentsItem
        v-for="item in data.items"
        :key="`content-${item.id}`"
        :item="item"
      />
    </template>
  </div>
</template>

<script>
import propsViaApi from "@/mixins/props-via-api";
export default {
  mixins: [propsViaApi],
  props: {
    items: Array,
  },
};
</script>

<style></style>
